export const CLASSES_NOT_STARTED_MESSAGE = 'No Classes Created'
export const NOT_STARTED_MESSAGE = 'with no lessons done'
